export default __webpack_public_path__ + "static/product-hero-robot-ab8baef5fae5fe019ee1d30b54d20eaf.png";